import * as passwordPolicy from './password-policy.reducer';
import * as userDetails from './user-details.reducer';
import * as travelCounsellors from './travel-counsellors.reducer';

export const reducers = {
  passwordPolicy: passwordPolicy.reducer,
  userDetails: userDetails.reducer,
  travelCounsellors: travelCounsellors.reducer,
};

export interface State {
  passwordPolicy: passwordPolicy.PasswordPolicyState;
  userDetails: userDetails.UserDetailsState;
  travelCounsellors: travelCounsellors.TravelCounsellorsState;
}
